module.exports = __webpack_public_path__ + "static/media/qrCode.3c70aa88.png";